import { createSlice } from '@reduxjs/toolkit';
// import { history } from '_helpers'; // Para redirección después de login (si se activa)

// --- Constantes ---
const name = 'role';  // Nombre del slice
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();

// --- Slice ---
const slice = createSlice({
    name,
    initialState,
    reducers,
    extraReducers
});

// --- Exports ---
export const userRoleActions = { ...slice.actions, ...extraActions };
export const userRoleReducer = slice.reducer;

// --- Implementación ---

/**
 * Crea el estado inicial del slice.
 * @returns {Object} Estado inicial con el rol del usuario y posibles errores.
 */
function createInitialState() {
    return {
        user: JSON.parse(localStorage.getItem('role')), // Carga rol desde localStorage si existe
        error: null
    };
}

/**
 * Define los reducers síncronos del slice.
 * Actualmente está vacío, pero se puede habilitar el logout.
 * @returns {Object} Objeto con reducers.
 */
function createReducers() {
    // Descomentar si se desea manejar logout
    /*
    return {
        logout
    };

    function logout(state) {
        state.user = null;
        localStorage.removeItem('role');
    }
    */
}

/**
 * Crea las acciones asíncronas del slice (extraActions).
 * Usa createAsyncThunk de Redux Toolkit.
 * @returns {Object} Acciones asíncronas como login (comentado por ahora).
 */
function createExtraActions() {
    //const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

    // Descomentar y adaptar cuando quieras agregar login
    /*
    return {
        login: login()
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async ({ username, password }) => await fetchWrapper.post(`${baseUrl}/authenticate`, { username, password })
        );
    }
    */
}

/**
 * Define los extraReducers que responden a acciones asíncronas (thunks).
 * @returns {Object} Reducers que manejan pending, fulfilled y rejected (comentado).
 */
function createExtraReducers() {
    // Descomentar y adaptar cuando actives login
    /*
    return {
        ...login()
    };

    function login() {
        var { pending, fulfilled, rejected } = extraActions.login;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const user = action.payload;
                localStorage.setItem('user', JSON.stringify(user));
                state.user = user;

                const { from } = history.location.state || { from: { pathname: '/' } };
                history.navigate(from);
            },
            [rejected]: (state, action) => {
                state.error = action.error;
            }
        };
    }
    */
}